(function(window) {
    function waitForDeferred(id, predicate, action) {
        function wait() {
            if (predicate()) {
                try {
                    action();
                } catch (ex) {}
            } else {
                setTimeout(wait, 100);
            }
        }

        requestAnimationFrame(wait);
    }

    window.waitForDeferred = waitForDeferred;
}(window));
